import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Line-by-line hero headline. Text always visible.
export function MaskedHeading({ lines = [], className = "" }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={`${i}-${line}`} className="block">
          {line}
        </span>
      ))}
    </span>
  );
}

// Simple wrapper — content always visible (animations removed for reliability).
export function Fade({ children, delay = 0, className = "" }) {
  return <div className={className}>{children}</div>;
}

// FadeUp — animation removed for reliability; content always visible.
export function FadeUp({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}

// Image reveal — CSS-based scale-in for reliability.
export function ImageReveal({ src, alt = "", className = "", imgClassName = "" }) {
  return (
    <div className={`overflow-hidden ${className}`}>
      <img src={src} alt={alt} loading="lazy" className={`img-cover ${imgClassName}`} />
    </div>
  );
}

export { EASE };
